import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'neutral' | 'accent' | 'success' | 'danger' | 'subtle';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Badge = ({ children, variant = 'neutral', size = 'md', className = '' }: BadgeProps) => {
  const baseClasses = 'inline-flex items-center justify-center font-semibold tracking-wide whitespace-nowrap';

  const variantClasses = {
    neutral: 'bg-surface-alt text-text-secondary border border-border',
    accent: 'bg-accent/10 text-accent border border-accent/40',
    success: 'bg-oro-success/10 text-oro-success border border-oro-success/40',
    danger: 'bg-oro-error/10 text-oro-error border border-oro-error/40',
    subtle: 'bg-surface text-text-muted border-0'
  };

  const sizeClasses = {
    sm: 'text-caption px-2 py-0.5 rounded',
    md: 'text-caption px-3 py-1 rounded-full',
    lg: 'text-xs px-3 py-1.5 rounded-full'
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <span className={classes}>
      {children}
    </span>
  );
};

export default Badge;